import OverrideGeoIPPropertiesIntro from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/override-geoip-properties-intro.mdx";
import * as React from 'react';
export default {
  OverrideGeoIPPropertiesIntro,
  React
};